var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{ref:"content",staticClass:"app-content",class:{'quick-start-pad': _vm.$store.state.tutorial.quickStart},style:({
    padding:'0px', 
    marginTop: _vm.top, 
    'overflow-y': 'auto', 
    'min-height': _vm.isHaveReportTable ? '300px' : 'initial',
  })},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }